import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { FlowchartDragDropService } from 'shared/domain';
import { IconDirective } from 'shared/ui-common';

import {
  ToolbarItemConfig,
  mainToolbarItems,
} from '../../../../../../shared/feature-flowchart/src/lib/infrastructure/operations/node-picker-toolbar/node-picker-toolbar-items.config';

@Component({
  standalone: true,
  selector: 'tt-flowchart-drag-palette',
  imports: [TranslocoModule, MatIconModule, IconDirective],
  templateUrl: './flowchart-drag-palette.component.html',
  styleUrls: ['./flowchart-drag-palette.component.scss'],
  host: {
    class: 'tt-flowchart-drag-palette',
  },
})
export class FlowchartDragPaletteComponent {
  private dragDropService = inject(FlowchartDragDropService);

  protected toolbarItems: ToolbarItemConfig[] = mainToolbarItems;

  protected onDragStart(event: DragEvent, item: ToolbarItemConfig, imageElement: HTMLImageElement): void {
    event.dataTransfer.clearData();
    event.dataTransfer.setData('application/x-flowchart-node', item.event);
    event.dataTransfer.effectAllowed = 'copy';
    event.dataTransfer.setDragImage(imageElement, 16, 16);
    this.dragDropService.startDrag(item.event);
  }

  protected onDragEnd(): void {
    this.dragDropService.endDrag();
  }
}
